import {
  Box,
  Flex,
  Link,
  Text,
  useBreakpointValue,
  Tooltip,
  Icon,
} from "@chakra-ui/react";
import Group from "../../ServicosAcolhimento/Visualizar/Group";
import TableSA from "../../../components/TableSA";
import React, { useState, useEffect } from "react";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { servicoAcolhimentoFunc } from "../../../../helpers/Funcionalidades";
import { telefone as telMask } from "../../../utils/masks";
import { Link as ReactLink } from "react-router-dom";
import LoadingSpinner from "../../../components/LoadingSpinner";
import ServicoAcolhimentoService from "../../../../main/services/ServicoAcolhimentoService";
import SemRegistros from "../../../components/SemRegistros";
import { PopoverGenero } from "../../../components/PopoverGenero";
import { IoHelpCircle } from "react-icons/io5";

export default function DashboardServicoAcolhimento() {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const { roleKeycloack, selectedProfile, selectedOrgao } = useAuthProvider();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [hintPreliminar, setHintPreliminar] = useState(false);
  const placement = useBreakpointValue({ md: "right" });

  useEffect(() => {
    let ignore = false;
    const getDadosServicosAcolhimento = async () => {
      setLoading(true);

      await ServicoAcolhimentoService.pesquisarServicosAcolhimentoDashboard()
        .then((res) => {
          if (ignore) return;
          const filteredData = res.data.filter((item) => !!item.nomeFantasia);
          setData(filteredData);
        })
        .catch(() => {
          if (!ignore) setData([]);
        })
        .finally(() => {
          if (!ignore) setLoading(false);
        });
    };
    getDadosServicosAcolhimento();
    return () => {
      ignore = true;
    };
  }, [selectedProfile, selectedOrgao]);

  const columns = [
    {
      Header: "Nome",
      accessor: "nomeFantasia",
      Cell: (props) => {
        const id = props.row.original.id;
        return (
          <Flex h={"40px"} alignItems="center">
            {roleKeycloack &&
            roleKeycloack.includes(servicoAcolhimentoFunc.visualizar) ? (
              <Link
                wordBreak={"break-all"}
                title={props.value}
                as={ReactLink}
                to={"/servico-acolhimento/" + id}
              >
                <Text minWidth="250px">{props.value}</Text>
              </Link>
            ) : (
              <Text minWidth="250px">{props.value}</Text>
            )}
          </Flex>
        );
      },
    },
    {
      Header: "Status",
      accessor: "status",
      sortType: (rowA, rowB, id, desc) => {
        const statusA =
          rowA.original.desativado === "S"
            ? "Desativado"
            : rowA.original.suspenso === "S"
            ? "Suspenso"
            : "Ativo";
        const statusB =
          rowB.original.desativado === "S"
            ? "Desativado"
            : rowB.original.suspenso === "S"
            ? "Suspenso"
            : "Ativo";
        return statusA.localeCompare(statusB, "pt-BR");
      },
      Cell: (props) => {
        return (
          <Text>
            {props.row.original.desativado === "S"
              ? "Desativado"
              : props.row.original.suspenso === "S"
              ? "Suspenso"
              : "Ativo"}
          </Text>
        );
      },
    },
    {
      Header: "Telefone",
      accessor: "telefones",
      Cell: (props) => {
        const tels = props.value;

        if (!tels) {
          return <span>{"Não possui telefone"}</span>;
        }

        return tels?.map((telefone, index) => {
          return (
            <React.Fragment key={index}>
              <span style={{ whiteSpace: "nowrap" }}>
                {telMask(telefone.telefone)}
              </span>
              {tels.length - 1 !== index && <br />}
            </React.Fragment>
          );
        });
      },
    },
    {
      Header: "Endereço",
      accessor: "endereco",
      Cell: (props) => {
        return <Text minWidth="300px">{props.value}</Text>;
      },
    },
  ];

  const renderizarVisitas = () => {
    if (isMobile)
      return (
        <PopoverGenero
          isOpen={hintPreliminar}
          setIsOpen={setHintPreliminar}
          flex={true}
          handleClick={() => setHintPreliminar(!hintPreliminar)}
          labelTextoGenero={
            "Serão exibidos todos os serviços de acolhimento com status ativo localizados na sua área de atuação."
          }
        />
      );

    return (
      <Tooltip
        label={
          "Serão exibidos todos os serviços de acolhimento com status ativo localizados na sua área de atuação."
        }
        fontSize="md"
        maxW="400px"
        textAlign={"justify"}
        placement={placement}
      >
        <span className="hint-tooltip">
          <Icon
            aria-label="Aviso de pendente"
            color="#6B6C71"
            as={IoHelpCircle}
            boxSize={{ base: "20px" }}
          />
        </span>
      </Tooltip>
    );
  };

  return (
    <Flex
      pt={"20px"}
      px={["5px", "30px"]}
      h="100%"
      flexDir="column"
      w="100%"
      maxW="2000px"
      overflow="auto"
      pb={["10px", "20px"]}
    >
      <Group
        title={
          <Flex>
            <Text textTransform="uppercase">Serviço de Acolhimento</Text>

            {roleKeycloack?.includes(
              servicoAcolhimentoFunc.visualizarParteMP
            ) && <> {renderizarVisitas()} </>}
          </Flex>
        }
        opcoes={true}
        voltar={true}
      >
        {!loading ? (
          <>
            {data && data.length > 0 ? (
              <TableSA
                data={data}
                columns={columns}
                loading={loading}
                entidade="servico-acolhimento"
                roleKeycloack={roleKeycloack}
                disableHeaderOptionsOpcoes
              />
            ) : (
              <Box>
                <SemRegistros half buttonVisible={true} />
              </Box>
            )}
          </>
        ) : (
          <Box mt={4}>
            <LoadingSpinner />
          </Box>
        )}
      </Group>
    </Flex>
  );
}
